<section class="widget-section" id="app-infoboxes">
  <div class="container" #heroZoneInfoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Hero" [appHideParentIfEmpty]="heroZoneInfoBoxContainer"></app-infobox-zone>
  </div>
</section>

<!-- featured news removed at customer request -->

<section class="widget-section order-1" id="app-my-news">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-my-news></app-my-news>
  </div>
</section>

<section class="widget-section order-2" id="app-custom-compliments-wall">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-custom-compliments-wall></app-custom-compliments-wall>
  </div>
</section>

<section class="widget-section order-3" id="app-custom-my-blogs">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <app-custom-my-blogs></app-custom-my-blogs>
  </div>
</section>

<section class="widget-section order-4" id="app-organization-calendar">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #organizationCalendarContainer>
    <app-organization-calendar appMarkComponentVisited [appHideParentIfEmpty]="organizationCalendarContainer"></app-organization-calendar>
  </div>
</section>

<section class="widget-section order-5">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #infoBoxContainer>
    <app-infobox-zone appMarkComponentVisited area="Default" [appHideParentIfEmpty]="infoBoxContainer"></app-infobox-zone>
  </div>
</section>

<section class="widget-section order-6">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6">
    <div class="row">
      <div class="col-12 col-lg" #birthdaysContainer *appFeatureToggle="'showBirthdayCalendar'">
        <app-birthdays [appHideParentIfEmpty]="birthdaysContainer"></app-birthdays>
      </div>
      <div class="col-12 col-lg" #restaurantMenuContainer *appFeatureToggle="'showRestaurantMenus'">
        <app-restaurant-menu [appHideParentIfEmpty]="restaurantMenuContainer"></app-restaurant-menu>
      </div>
    </div>
  </div>
</section>

<section class="widget-section order-7" id="app-rss-feeds">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #rssFeedsContainer>
    <app-rss-feeds [appHideParentIfEmpty]="rssFeedsContainer"></app-rss-feeds>
  </div>
</section>

<section class="widget-section order-8" id="app-power-bi">
  <div class="container pt-4 pb-4 pt-lg-6 pb-lg-6" #powerBIFramesContainer>
    <app-power-bi appMarkComponentVisited [appHideParentIfEmpty]="powerBIFramesContainer"></app-power-bi>
  </div>
</section>

<section class="widget-section order-9" id="app-kpi-charts">
  <div class="container" #kpiContainer>
    <div class="row">
      <div class="col-12 col-lg pt-4 pb-4 pt-lg-6 pb-lg-6">
        <app-kpi-charts [appHideParentIfEmpty]="kpiContainer"></app-kpi-charts>
      </div>
    </div>
  </div>
</section>
